<template>
  <div class="story-wrapper">
    <div
      class="story-frame"
      :style="{
        backgroundImage: `url(${post?.file?.preview})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }"
    >
      <!-- Top Header -->
      <div class="story-header d-flex align-center justify-start px-3 py-2">
        <v-avatar size="28" class="me-2">
          <img src="https://i.pravatar.cc/300" />
        </v-avatar>
        <div class="d-flex flex-column">
          <span class="font-weight-bold text-white">Ruffles</span>
          <span class="text-caption text-white text-opacity-75">18h</span>
        </div>
      </div>

      <div v-if="post?.file" >
        <!-- Story Image -->
        <video
          v-if="
            post?.file?.file &&
            post?.file?.file.type &&
            post?.file?.file?.type.startsWith('video/')
          "
          height="100%"
          :src="post?.file?.preview"
          autoplay
          muted
          loop
          class="story-media w-100"
        ></video>
      </div>
      <div v-else></div>
      <!-- Bottom Controls -->
      <div
        class="story-footer d-flex align-center justify-space-between px-3 py-2"
      >
        <img
          src="@/assets/images/instgramStorybottom.png"
          class="w-100"
          alt=""
        />
      </div>

      <!-- Progress Bar -->
      <v-progress-linear color="white" height="3" indeterminate absolute top />
    </div>
  </div>
</template>

<script>
import { publishPost } from "@/store/publishPost/publishPost.js";
export default {
  name: "InstgramStoryReview",
  components: {},
  data() {
    return {
      store: publishPost(),
      post: {},
    };
  },
  watch: {
    "store.getCarouselSlider": {
      handler() {
        this.post = this.store.post["instagram"].find(
          (item) => item.type === "story"
        );
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.story-wrapper {
  width: 100%;
  max-width: 420px;
  aspect-ratio: 9 / 16;
  margin: auto;
  position: relative;
}

.story-frame {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 24px;
  overflow: hidden;
  background-color: #000;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.story-header {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), transparent);
  width: 100%;
}

.story-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
  width: 100%;
}

.story-input input {
  color: black !important;
  font-size: 14px;
}

.story-background ::v-deep(.v-img__img) {
  object-position: center center;
}
</style>
